/* eslint-disable no-constant-condition */
import { RemoteConstantPromoCode } from '51trips-frontend-core'

type RemoteConstantPromoCodeConverterFirebaseObject = {
  code: string
  dateToShowCountdown: number
  discount: string
  endDate: number
  isActive: boolean
}

const remoteConstantPromoCodeConverter = {
  fromFirestore: (data: RemoteConstantPromoCodeConverterFirebaseObject) => {
    if (data) {
      let code: string | undefined
      if (typeof data.code === 'string') {
        code = data.code
      }

      let dateToShowCountdown: number | undefined
      if (typeof data.dateToShowCountdown === 'number') {
        dateToShowCountdown = data.dateToShowCountdown
      }

      let discount: string | undefined
      if (typeof data.discount) {
        discount = data.discount
      }

      let endDate: number | undefined
      if (typeof data.endDate === 'number') {
        endDate = data.endDate
      }

      let isActive: boolean | undefined
      if (typeof data.isActive) {
        isActive = data.isActive
      }

      return new RemoteConstantPromoCode(code, dateToShowCountdown, discount, endDate, isActive)
    } else {
      return undefined
    }
  }
}

export default remoteConstantPromoCodeConverter
